<template>
  <div
    :class="[
      'c-button c:row-center',
      type,
      primary ? 'primary' : undefined,
      disabled ? 'disabled' : undefined,
      small ? 'small' : undefined,
      large ? 'large' : undefined,
      loading ? 'loading' : undefined,
    ]"
    @click="throttledOnClick"
  >
    <slot />
  </div>
</template>

<script>
import { throttle } from "@/utils";

export default {
  props: {
    type: {
      type: String,
      default: "default",
    },
    primary: {
      type: Boolean,
      default: false,
    },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    throttleTime: { type: Number, default: 500 },
  },
  watch: {
    throttleTime: {
      immediate: true,
      handler() {
        this.throttledOnClick = throttle(this.onClick, this.throttleTime);
      },
    },
  },
  methods: {
    onClick(e) {
      // console.log("this", this);
      if (this.disabled || this.loading) return;
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="less" scoped>
.c-button {
  box-sizing: border-box;
  width: 100%;
  height: 46/20rem;
  border: solid 1px #000;
  line-height: 24/20rem;
  font-size: 16/20rem;
  font-weight: 400;
  color: #000;

  &.small {
    height: 38/20rem;
  }

  &.large {
    height: 46/20rem;
  }

  &.disabled {
    border: solid 1px #b8b8b8;
    color: #b8b9b8;
  }

  &.primary {
    background-color: #000;
    color: #fff;
    &.disabled {
      background-color: #b8b8b8;
      color: #fff;
    }
  }

  &.loading {
    opacity: 0.6;
  }
}
</style>
